import { createSlice, Draft } from '@reduxjs/toolkit'
import { ICrmInfoRes } from '../../interfaces/crmInfo'

const initialState: ICrmInfoRes = {
  id: '',
  name: '',
  price: null,
  billingDate: '',
  isActive: true,
  jivoToken: null,
  balance: 0,
  permission: {
    generator: false,
    salary: false,
    statistic: false,
    whiteList: false,
    scripts: false,
    tests: false,
    viber: false,
    telegram: false,
    watsApp: false,
    cabinets: false,
  },
}

export const crmInfoSlice = createSlice({
  name: 'crmInfo',
  initialState,
  reducers: {
    setCrmInfo: (state: Draft<ICrmInfoRes>, { payload }) => {
      state.id = payload.id
      state.name = payload.name
      state.price = payload.price
      state.billingDate = payload.billingDate
      state.isActive = payload.isActive
      state.permission = payload.permission
      state.jivoToken = payload.jivoToken
    },
    setJivoToken: (state: Draft<ICrmInfoRes>, { payload }) => {
      state.jivoToken = payload
    },
    setBillingDate: (state: Draft<ICrmInfoRes>, { payload }) => {
      state.billingDate = payload
    },
    setBalace: (state: Draft<ICrmInfoRes>, { payload }) => {
      state.balance = payload
    },
    clearCrmInfo: (state: Draft<ICrmInfoRes>) => {
      state = initialState
    },
  },
})

export const { setCrmInfo, clearCrmInfo, setJivoToken, setBillingDate, setBalace } =
  crmInfoSlice.actions

export default crmInfoSlice.reducer
